/* eslint-disable @trello/disallow-filenames */
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// Removes Text Ranges
// http://stackoverflow.com/a/3169849/616931

export const removeAllRanges = function () {
  if (window.getSelection) {
    // @ts-expect-error TS(2531): Object is possibly 'null'.
    if (window.getSelection().empty) {
      // Chrome
      // @ts-expect-error TS(2531): Object is possibly 'null'.
      return window.getSelection().empty();
      // @ts-expect-error TS(2531): Object is possibly 'null'.
    } else if (window.getSelection().removeAllRanges) {
      // Firefox
      // @ts-expect-error TS(2531): Object is possibly 'null'.
      return window.getSelection().removeAllRanges();
    }
    // @ts-expect-error TS(2339): Property 'selection' does not exist on type 'Docum... Remove this comment to see the full error message
  } else if (document.selection) {
    // IE?
    // @ts-expect-error TS(2339): Property 'selection' does not exist on type 'Docum... Remove this comment to see the full error message
    return document.selection.empty();
  }
};
